"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _classnames = _interopRequireDefault(require("classnames"));

var _sharedCss = _interopRequireDefault(require("../../shared/oldDocumentSignerUI/sharedCss"));

var _fieldStatusClass = _interopRequireDefault(require("./fieldStatusClass"));

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = _objectSpread({}, _sharedCss.default.fields, {
  root: {
    position: 'absolute',
    padding: 5
  },
  setButton: {
    position: 'absolute',
    right: 5,
    bottom: 5,
    height: 36,
    width: 36
  },
  buttonIcon: {
    height: 20
  }
});

var Timestamp = function Timestamp(props) {
  var _props$classes = props.classes,
      classes = _props$classes === void 0 ? {} : _props$classes,
      format = props.format,
      handleChange = props.handleChange,
      height = props.height,
      id = props.id,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      width = props.width,
      x = props.x,
      y = props.y,
      setFieldRef = props.setFieldRef,
      isDisabled = props._derived.isDisabled;
  var fieldStyle = {
    top: y,
    left: x,
    height: height,
    width: width,
    fontSize: height * 0.8
  };
  var fieldClass = (0, _classnames.default)(classes.root, (0, _fieldStatusClass.default)(props));
  var safeFormat = (format || 'MM/DD/YYYY').toUpperCase();

  var setDate = function setDate() {
    return handleChange((0, _moment.default)().format(safeFormat));
  };

  return _react.default.createElement("div", {
    className: fieldClass,
    style: fieldStyle,
    "data-test-id": "Timestamp-root-".concat(id),
    ref: function ref(el) {
      return setFieldRef(el, y);
    }
  }, _react.default.createElement(_core.Typography, null, value), !isDisabled && _react.default.createElement(_core.Fab, {
    className: classes.setButton,
    onClick: setDate,
    "data-test-id": "Timestamp-button-".concat(id)
  }, _react.default.createElement(_icons.CalendarToday, {
    className: classes.buttonIcon
  })));
};

var _default = (0, _styles.withStyles)(styles)(Timestamp);

exports.default = _default;